export function isMorningTime(): boolean {
  const currentHour = new Date().getHours()
  console.warn('currentHour:', currentHour)
  return currentHour >= 8 && currentHour < 11
}
